import React, { useState } from 'react';
import TimelinePresenter from './TimelinePresenter';
import DTOTimeline from './DTOTimeline';
import { useAppSelector } from '../../../../infra/hooks';
import { useTranslation } from 'react-i18next';

function TImelineController() {
  const { t } = useTranslation();

  const [timelineList, setTimelineList] = useState([]);

  const isLoading = useAppSelector(
    (state) => state.timelineSlice.timelineLoader,
  );
  function birthdayCallBack(timelines: []) {
    setTimelineList(timelines);
  }
  return (
    <>
      <DTOTimeline setTimeline={birthdayCallBack} />
      <TimelinePresenter
        timeline={timelineList}
        isLoading={isLoading}
        trans={t}
      />
    </>
  );
}

export default TImelineController;
